module.exports = __webpack_public_path__ + "img/ee.b616f78e.svg";